const youtubeParser = (url) => {
  var _a;
  const formattedUrl = url == null ? void 0 : url.trim();
  if (!formattedUrl)
    return "";
  const regExp = new RegExp("^(https?:\\/\\/)?(www\\.)?(youtu\\.be\\/|youtube\\.com\\/(embed\\/|v\\/|watch\\?(.+&)*v=))(?<videoId>(\\w|-)+)");
  const { videoId } = ((_a = regExp.exec(formattedUrl)) == null ? void 0 : _a.groups) || {};
  return (videoId == null ? void 0 : videoId.length) === 11 ? videoId : "";
};

export { youtubeParser };
